import type { ProductCategory, Product } from '@/types/product';
import { productCategories } from '@/data/products';
// Caching removed per request: always load fresh data from source

export async function loadProductData(): Promise<ProductCategory[]> {
  // Always load from in-repo source (no cache)
  console.log('Loading product data (no cache)');
  // Simulate API delay for UX consistency
  await new Promise(resolve => setTimeout(resolve, 50));
  return productCategories;
}

export async function refreshProductData(): Promise<ProductCategory[]> {
  // Kept for API compatibility; identical to loadProductData without caching
  console.log('Refreshing product data (no cache)');
  await new Promise(resolve => setTimeout(resolve, 50));
  return productCategories;
}

export function getProductById(categories: ProductCategory[], id: string): Product | null {
  for (const category of categories) {
    const product = category.products.find(p => p.id === id);
    if (product) return product;
  }
  return null;
}

export function getProductsByCategory(categories: ProductCategory[], categoryId: string): Product[] {
  const category = categories.find(c => c.id === categoryId);
  return category?.products || [];
}